import React, { useRef, useState, useMemo } from "react";
import { Sidebar } from 'primereact/sidebar';
import { Dock } from 'primereact/dock';
import ToggleConnect from './ToggleConnect';
import { useWeb3React } from "@web3-react/core";
import { useNavigate } from "react-router-dom";

// Images
import rocketfiIcon from './imgs/rocketfi_yellow_token.png';
import radarIcon from './imgs/radar_blue_icon.png';
import floatieIcon from './imgs/floatie_pink_icon_bw.png';
import refuelIcon from './imgs/refuel_color_icon.png';
import ultraIcon from './imgs/ultrablue_color_icon.png';
import { get } from "https-browserify";

const NavigationBar = ({ changeTheme, updateDefiApp, defiApp }) => {

    const toggleConnectRef = useRef();
    
    const [visibleDock, setVisibleDock] = useState(false);
    const { activate, deactivate, account } = useWeb3React();
    const navigate = useNavigate();


    const getDockItemCommand = (app) => {
        return () => {
            updateDefiApp(app);
            navigate(`/${app.toLowerCase()}`);
            setVisibleDock(false);
        };
    };

    const items = useMemo(() => [
        {
            label: 'RocketFi',
            icon: () => <img alt="RocketFi" src={rocketfiIcon} width="100%" />,
            command: getDockItemCommand("RocketFi"),
            disabled: defiApp === "RocketFi"
        },
        {
            label: 'Radar',
            icon: () => <img alt="Radar" src={radarIcon} width="100%" />,
            command: getDockItemCommand("Radar"),
            disabled: defiApp === "Radar"
        },
        {
            label: 'Refuel',
            icon: () => <img alt="Refuel" src={refuelIcon} width="100%" />,
            command: getDockItemCommand("Refuel"),
            disabled: defiApp === "Refuel"
        },
        {
            label: 'Ultra',
            icon: () => <img alt="Ultra" src={ultraIcon} width="100%" />,
            command: getDockItemCommand("Ultra"),
            disabled: defiApp === "Ultra"
        },
        {
            label: 'Floatie',
            icon: () => <img alt="Floatie" src={floatieIcon} width="100%" />,
            command: getDockItemCommand("Floatie"),
            disabled: defiApp === "Floatie"
        }
    ], [defiApp]);

    const customIcons = (
        <React.Fragment>
            <button className="p-sidebar-icon p-link mr-2">
                <span className="pi pi-sign-out" onClick={() => { toggleConnectRef.current.toggleConnect(); }} />
            </button>
        </React.Fragment>
    );

    return (
        <div>
            <div style={{ alignItems: 'left', justifyContent: 'left', paddingLeft: '20px', paddingTop: '20px', display: 'inline-block' }}>
                <ToggleConnect toggled={true} defiApp={defiApp} onToggle={() => setVisibleDock(true)} ref={toggleConnectRef}></ToggleConnect>
            </div>
            <Sidebar visible={visibleDock} position="top" icons={customIcons} onHide={() => setVisibleDock(false)}>
                <Dock model={items} position={'bottom'} style={{ paddingBottom: "25px", paddingTop: "25px", justifyContent: "center" }} />
            </Sidebar>
        </div>
    );
}

export default React.memo(NavigationBar);